import { type ReactElement } from 'react';
import { Text } from '@mantine/core';

interface Props {
  height: number;
}

export const HeaderLayer = (props: Props): ReactElement => {
  const { height } = props;
  return (
    <div className="flex flex-row" style={{ height }}>
      {(() => {
        const hours = [];
        for (let hour = 0; hour <= 23; hour++) {
          hours.push(
            <div
              key={`header-tile-${hour}`}
              className="flex w-full justify-start items-center ml-[-0.5rem]"
            >
              {hour === 0 ? <></> : <Text fw={500} size="sm">{hour < 10 ? `0${hour}` : hour}</Text>}
            </div>
          );
        }
        return hours;
      })()}
    </div>
  );
};
